import PDFWrapper, { Row } from '../PdfLayout';
import PDFTable from './Table';
import AttendanceReportProps from './types';

function AttendanceReport({ data }: { data: AttendanceReportProps }): React.ReactElement {
  const labels = {
    name: 'Name of Student:',
    USI: 'USI:',
    dob: 'Date of Birth:',
    course: 'Course:',
    startDate: 'Commencement Date:',
  };

  return (
    <PDFWrapper title="Weekly Attendance Record">
      {Object.keys(data)
        .filter((key) => key in labels)
        .map((key, index) => (
          <Row key={index} label={labels[key]} value={data[key]} />
        ))}
      <PDFTable data={data.attendanceRecord} />
    </PDFWrapper>
  );
}

export default AttendanceReport;
